// @flow
import LoginForm from './LoginForm';
export default LoginForm;



// WEBPACK FOOTER //
// ./src/routes/Login/components/LoginForm/index.js